import React, { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import { Input } from '@eika/input';

import { maskFoedselsdato, validFoedselsdato } from '../../infra/date';
import { useTranslation } from '../../translations';
import { BarnFormData } from './barn';

interface Props {
    index: number;
    control: Control<BarnFormData>;
    errors: FieldErrors<BarnFormData>;
}

const Foedselsdato: FC<Props> = ({ index, control, errors }) => {
    const { barn, validationMessage } = useTranslation();

    return (
        <Controller
            name={`barn.${index}.foedselsdato` as const}
            control={control}
            rules={{
                required: `${validationMessage.requiredValue}`,
                validate: { dateNotValid: (value) => validFoedselsdato(value || '') },
            }}
            render={({ field: { onChange, value } }) => (
                <Input
                    inputMode="numeric"
                    label={barn.labelFoedselsdato}
                    placeholder="dd.mm.åååå"
                    className="max-width-200"
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(maskFoedselsdato(e.target.value))}
                    error={
                        errors.barn?.[index]?.foedselsdato?.type === 'dateNotValid'
                            ? `${validationMessage.foedselsdatoUnder18aar}`
                            : errors.barn?.[index]?.foedselsdato?.message
                    }
                />
            )}
        />
    );
};

export default Foedselsdato;
